// @flow

import { SimpleEntity } from '../abstract/SimpleEntity';
import type { EntityFieldCollection } from '../types';

class BillTax implements SimpleEntity {
    static fields: EntityFieldCollection = {
        name: {
            displayName: 'Name',
            recordName: 'name',
            dataType: {
                primitive: 'str',
                isArray: false,
                extraData: null,
            },
            isOptional: false,
        },
        amount: {
            displayName: 'Amount',
            recordName: 'amount',
            dataType: {
                primitive: 'amt',
                isArray: false,
                extraData: null,
            },
            isOptional: false,
        },
    };

    constructor(record: any) {
        this.record = record;
    }
}

export default BillTax;
